import { createTheme } from "@mui/material";

// Augment the palette to include an ochre color
declare module "@mui/material/styles" {
  interface Palette {
    quizTitle: Palette["primary"];
    quizQuestionBody: Palette["primary"];
    quizResponseButton: Palette["primary"];
    quizResponseButtonSelected: Palette["primary"];
    quizNavigationRow: Palette["primary"];
    quizNavigationButton: Palette["primary"];
  }

  interface PaletteOptions {
    quizTitle?: Palette["primary"];
    quizQuestionBody?: Palette["primary"];
    quizResponseButton: Palette["primary"];
    quizResponseButtonSelected?: Palette["primary"];
    quizNavigationRow?: Palette["primary"];
    quizNavigationButton?: Palette["primary"];
  }
}

// Update the Button's color options to include an ochre option
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    quizResponseButton: true;
    quizResponseButtonSelected: true;
    quizNavigationButton: true;
  }
}

export const theme = createTheme({
  palette: {
    mode: "light",

    quizTitle: {
      main: "#669BBC",
      light: "#669BBC",
      dark: "#669BBC",
      contrastText: "#FFFFFF",
    },
    quizNavigationRow: {
      main: "#669BBC",
      light: "#669BBC",
      dark: "#669BBC",
      contrastText: "#FFFFFF",
    },
    quizNavigationButton: {
      main: "#CAE9FF",
      light: "#CAE9FF",
      dark: "#CAE9FF",
      contrastText: "#1B4965",
    },
    quizQuestionBody: {
      main: "#004163",
      light: "#004163",
      dark: "#004163",
      contrastText: "#FFFFFF",
    },
    quizResponseButton: {
      main: "#8C002E",
      light: "#8C002E",
      dark: "#8C002E",
      contrastText: "#FFFFFF",
    },
    quizResponseButtonSelected: {
      main: "#0BB1C3",
      light: "#0BB1C3",
      dark: "#0BB1C3",
      contrastText: "#FFFFFF",
    },
  },
});
